<app-dialog-header [title]="combo ? 'Editar ingresso combo' : 'Adicionar ingresso combo'"></app-dialog-header>

<mat-dialog-content>
  <div class="modal-combo">
    <form [formGroup]="comboForm" (ngSubmit)="saveCombo()">
      <div class="modal-combo__body">
        <div class="mb-3">
          <label class="form-label" for="comboTitle">Título *</label>
          <input id="comboTitle" class="form-control" formControlName="title" placeholder="Ex.: Combo Pista + VIP" />
        </div>

        <div class="mb-3">
          <label class="form-label" for="comboSourceBatch">Lote do combo *</label>
          <select
            id="comboSourceBatch"
            class="form-select"
            formControlName="source_batch_key"
            [class.is-invalid]="
              comboForm.controls.source_batch_key.touched &&
              comboForm.controls.source_batch_key.invalid
            ">
            <option value="" disabled>Selecione o lote</option>
            @for (lot of availableLots; track lot.key) {
              <option [value]="lot.key">{{ lot.label }}</option>
            }
          </select>
          <p class="combo-lote-hint">
            O combo vale só para os ingressos individuais deste lote. Crie outro combo para o 2º ou 3º lote.
          </p>
        </div>

        <section class="combo-tickets-picker" aria-label="Ingressos do pacote">
          <div class="combo-tickets-picker__header">
            <p class="combo-tickets-picker__title">
              Ingressos e quantidade no pacote *
              @if (selectedLoteLabel) {
                <span class="combo-tickets-picker__lote">{{ selectedLoteLabel }}</span>
              }
            </p>
            <p class="combo-tickets-picker__subtitle">
              Defina quantas unidades de cada ingresso entram em 1 combo. Ex.: 2 Pista + 2 VIP, ou 2 unidades do mesmo
              ingresso (compre 1, leve 2).
            </p>
          </div>

          @if (availableLots.length < 1) {
            <p class="combo-tickets-picker__empty">
              Crie pelo menos um ingresso individual no passo anterior para montar o pacote.
            </p>
          } @else if (!comboForm.controls.source_batch_key.value) {
            <p class="combo-tickets-picker__empty">Selecione o lote para ver os ingressos disponíveis.</p>
          } @else if (optionsInSelectedLote.length < 1) {
            <p class="combo-tickets-picker__empty">Este lote ainda não tem ingresso individual.</p>
          } @else {
            <div class="combo-tickets-picker__list" role="group">
              @for (ticket of optionsInSelectedLote; track ticket.key) {
                <div
                  class="combo-ticket-option"
                  [class.combo-ticket-option--selected]="isSelected(ticket.key)">
                  <button
                    type="button"
                    class="combo-ticket-option__select"
                    (click)="toggleTicket(ticket.key, !isSelected(ticket.key))">
                    <span class="combo-ticket-option__check" aria-hidden="true">
                      @if (isSelected(ticket.key)) {
                        <i class="pi pi-check"></i>
                      }
                    </span>
                    <span class="combo-ticket-option__copy">
                      <span class="combo-ticket-option__name">{{ ticket.title }}</span>
                      <span class="combo-ticket-option__stock">Estoque {{ ticket.quantity }}</span>
                    </span>
                  </button>
                  @if (isSelected(ticket.key)) {
                    <div class="combo-ticket-option__qty">
                      <span class="combo-ticket-option__qty-label">Neste combo</span>
                      <button
                        type="button"
                        class="combo-ticket-option__qty-btn"
                        (click)="decreaseUnits(ticket.key, $event)"
                        [disabled]="unitsFor(ticket.key) <= 1"
                        aria-label="Diminuir quantidade neste combo">
                        <i class="pi pi-minus"></i>
                      </button>
                      <span class="combo-ticket-option__qty-value">{{ unitsFor(ticket.key) }}</span>
                      <button
                        type="button"
                        class="combo-ticket-option__qty-btn"
                        (click)="increaseUnits(ticket.key, $event)"
                        [disabled]="unitsFor(ticket.key) >= ticket.quantity"
                        aria-label="Aumentar quantidade neste combo">
                        <i class="pi pi-plus"></i>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
            <p class="combo-tickets-picker__count">
              {{ totalPackageUnits }}
              {{ totalPackageUnits === 1 ? "ingresso" : "ingressos" }} neste pacote
              @if (maxAllowedQuantity > 0 && limitingTicket) {
                · cota máxima {{ maxAllowedQuantity }}, limitada pelo {{ limitingTicket.title }}
              }
            </p>
          }
        </section>

        <div class="mb-3">
          <label class="form-label" for="comboDescription">Descrição *</label>
          <textarea id="comboDescription" class="form-control" rows="3" formControlName="description"></textarea>
        </div>

        <div class="row modal-combo__metrics">
          <div class="col-md-4 mb-3">
            <div class="d-flex flex-column h-100">
              <label class="form-label" for="comboQuantity">Quantidade máxima de venda *</label>
              <input
                id="comboQuantity"
                class="form-control mt-auto"
                type="number"
                min="1"
                formControlName="quantity" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="d-flex flex-column h-100">
              <label class="form-label" for="comboPrice">Preço do pacote *</label>
              <div class="input-group mt-auto">
                <span class="input-group-text">R$</span>
                <input
                  id="comboPrice"
                  class="form-control"
                  type="number"
                  min="1"
                  step="0.01"
                  formControlName="price" />
              </div>
            </div>
          </div>
          <div class="col-md-2 mb-3">
            <div class="d-flex flex-column h-100">
              <label class="form-label" for="comboMin">Mín. por compra</label>
              <input
                id="comboMin"
                class="form-control mt-auto"
                type="number"
                min="1"
                formControlName="min_per_buyer" />
            </div>
          </div>
          <div class="col-md-2 mb-3">
            <div class="d-flex flex-column h-100">
              <label class="form-label" for="comboMax">Máx. por compra</label>
              <input
                id="comboMax"
                class="form-control mt-auto"
                type="number"
                min="1"
                formControlName="max_per_buyer" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button type="button" styleType="outlined" (btnClick)="closeModal()">Cancelar</app-button>
  <app-button type="button" styleType="primary" (btnClick)="saveCombo()">Salvar</app-button>
</mat-dialog-actions>
